import { render, staticRenderFns } from "./HorizontalTitleListGraphql.vue?vue&type=template&id=240d19ed"
import script from "./HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
export * from "./HorizontalTitleListGraphql.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HorizontalTitleListGraphql.vue?vue&type=style&index=0&id=240d19ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports